<template>
    <a href="javascript;" class="tips-tricks-block" @click.prevent="openModal">
        <div class="tips-tricks-block__image-wrapper">
            <img :src="image.path" alt="" class="tips-tricks-block__image">
        </div>

        <div class="tips-tricks-block__content">
            <div class="tips-tricks-block__text-wrapper">
                <h3 class="tips-tricks-block__heading">{{ heading }}</h3>
                <p class="tips-tricks-block__description">{{ shortDescription }}</p>
            </div>
        </div>
    </a>
</template>

<script>
    export default {
        name: 'TipsTricksBlock',
        props: {
            heading: {
                type: String,
                required: true
            },
            shortDescription: {
                type: String,
                required: true
            },
            image: {
                type: Object,
                required: true
            }
        },
        methods: {
            openModal() {
                this.$emit('open-modal');
            }
        }
    }
</script>